export enum IntegrationType {
  Braze = `braze`,
  Marketo = `marketo`,
  UrbanAirship = `urbanairship`,
  FacebookAds = `facebookads`,
  GoogleAds = `googleads`,
  Iterable = `iterable`,
  TestPartnerWebhookIntegration = `testpartnerwebhook`,
  MoengageWebhook = `moengagewebhook`,
  ChameleonWebhook = `chameleonwebhook`,
  AppcuesWebhook = `appcueswebhook`,
  InsiderWebhook = `insiderwebhook`,
  LeanplumWebhook = `leanplumwebhook`,
  OnesignalWebhook = `onesignalwebhook`,
}

export enum ExportModalStep {
  History = 1,
  SelectType,
}

export enum ExportStatus {
  Created = 0,
  Started,
  Finished,
  Errored,
}
